<template>
  <div class="bannerBox" :style="bannerStyle">
    <div class="swiper-container bannerSwiper"  @mouseenter="openShow" @mouseleave="closeShow">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
          <a
            v-if="item.urlType == 1"
            :href="item.url"
            target="_blank"
            :title="item.title"
          >
            <img class="swiper_img" :src="item.fileName" style="width: 100% ; height: 100% ;" />
          </a>
          <a
            v-if="item.urlType == 2"
            :href="`/list/${item.url}`"
            target="_blank"
            :title="item.title"
          >
            <img class="swiper_img" :src="item.fileName" style="width: 100% ; height: 100% ;" />
          </a>
          <a
            v-if="item.urlType == 3"
            :href="`/detail/${0}/${item.url}`"
            target="_blank"
            :title="item.title"
          >
            <img class="swiper_img" :src="item.fileName" style="width: 100% ; height: 100% ;" />
          </a>
          <a v-if="item.urlType == 4" :title="item.title">
            <img class="swiper_img" :src="item.fileName" style="width: 100% ; height: 100% ;" />
          </a>
        </div>
      </div>
      <div class="swiper-button-prev swiper-button-prev-banner" :class="{ active: isShowv }"></div>
      <div class="swiper-button-next swiper-button-next-banner" :class="{ active: isShowv }"></div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper"
import { getAdvert } from '@/api/common'
export default {
  props: {
    height: {
      type: Number,
      default: 540
    }
  },
  data() {
    return {
      bannerList: [],
      bannerStyle: {},
      isShowv: false,
    }
  },
  mounted() {
    var _this = this

    _this.bannerStyle = {
      height: _this.height + 'px'
    }
    _this.bannerSwiper()
  },
  methods: {
    bannerSwiper(){
      var _this = this
      let data = {
        applicationUuid: _this.webId,
        advertType: 1
      }
      getAdvert(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          data.length && data.forEach(line => {
            if (line.fileName && line.fileName !== '') {
              _this.bannerList.push(line)
            }
          })
          this.$nextTick(() => {
            new Swiper(".bannerSwiper", {
              effect : 'fade',
              loop: true,
              speed: 300,
              autoplay: 2000,
              updateOnImagesReady: true,
              observer: true,
              observeParents: true,
              observeSlideChildren: true,
              autoplayDisableOnInteraction: false,
              // pagination : '.swiper-pagination',
              prevButton: '.swiper-button-next-banner',
              nextButton: '.swiper-button-prev-banner',
              paginationClickable :true,
            })
          })
        }
      })
    },
    // 打开左右箭头
    openShow() {
      this.isShowv = true
    },
    closeShow() {
      this.isShowv = false
    },
  }
}
</script>
<style lang="scss">
.bannerBox{
  width: 100%;
  /*max-width: 1920px; */
  margin: 0 auto;
}
/* .bannerSwiper {
  height: 100%;
}
.bannerBox .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
} */
.bannerBox .swiper-container {
  .swiper-wrapper {
    .swiper-slide {
      width: 100%;
      text-align: center;
      position: relative;
      overflow: hidden;
      height: 540px;
    }
  }
}

.bannerBox .swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  background-image: url('../assets/image/leftimg.png');
  background-size: cover;
  position: absolute;
  top: 45%;
  margin-top: -15px;
  width: 30px;
  height: 50px;
  z-index: 89;
  opacity: 0.5;
}

.bannerBox .swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  background-image: url('../assets/image/rightimg.png');
  background-size: cover;
  position: absolute;
  top: 45%;
  margin-top: -15px;
  width: 30px;
  height: 50px;
  z-index: 89;
  opacity: 0.5;
}

.bannerBox .swiper-button-prev {
  left: -40px;
  transition: all 0.3s linear;
  -moz-transition: 0.3s all linear;
  -webkit-transition: 0.3s all linear;
  -o-transition: 0.3s all linear;
  -ms-transition: 0.3s all linear;
}

.bannerBox .swiper-button-next {
  right: -40px;
  transition: all 0.3s linear;
  -moz-transition: 0.3s all linear;
  -webkit-transition: 0.3s all linear;
  -o-transition: 0.3s all linear;
  -ms-transition: 0.3s all linear;
}

.bannerBox .swiper-button-prev.active {
  left: 10px;
}

.bannerBox .swiper-button-next.active {
  right: 10px;
}

</style>